import api from './../../lib/api';

export const COHORTS_LIST_LOAD = 'COHORTS_LIST_LOAD';
export const COHORTS_LIST_LOAD_SELECT = 'COHORTS_LIST_LOAD_SELECT';
export const COMPANIES_COHORTS_LIST_LOAD = 'COMPANIES_COHORTS_LIST_LOAD';
export const COHORT_LOAD = 'COHORT_LOAD';
export const COHORT_CREATE = 'COHORT_CREATE';
export const COHORT_UPDATE = 'COHORT_UPDATE';
export const COHORT_DELETE = 'COHORT_DELETE';
export const COHORT_SET_EMPTY = 'COHORT_SET_EMPTY';

const COHORTS_LIST_LOADING_CHANGE = 'COHORTS_LIST_LOADING_CHANGE';
const COHORTS_LIST_CHANGE = 'COHORTS_LIST_CHANGE';
const COMPANIES_COHORTS_LIST_LOADING_CHANGE = 'COMPANIES_COHORTS_LIST_LOADING_CHANGE';
const COMPANIES_COHORTS_LIST_CHANGE = 'COMPANIES_COHORTS_LIST_CHANGE';
const COHORT_CHANGE = 'COHORT_CHANGE';
const COHORT_LOADING_CHANGE = 'COHORT_LOADING_CHANGE';
const COHORT_ERRORS_CHANGE = 'COHORT_ERRORS_CHANGE';
const COHORT_SAVING_CHANGE = 'COHORT_SAVING_CHANGE';
const COHORT_DELETING_CHANGE = 'COHORT_DELETING_CHANGE';
const COHORT_EMPTY = 'COHORT_EMPTY';
const COHORTS_LIST_LOADING_CHANGE_SELECT = 'COHORTS_LIST_LOADING_CHANGE_SELECT';
const COHORTS_LIST_CHANGE_SELECT = 'COHORTS_LIST_CHANGE_SELECT';

const cohort_empty = () => {
    return {
        name: '',
        description: '',
        priority: 0,
        rules: [],
        is_active: true,
        triggers: {
            activated: [],
        },
    };
};

const state = {
    cohorts_list: [],
    cohorts_list_total: 0,
    cohorts_list_per_page: 20,
    cohorts_list_page: 1,
    cohorts_list_loading: false,

    cohorts_list_select: [],
    cohorts_list_select_total: 0,
    cohorts_list_select_per_page: 20,
    cohorts_list_select_page: 1,
    cohorts_list_select_loading: false,

    companies_cohorts_list: [],
    companies_cohorts_list_total: 0,
    companies_cohorts_list_per_page: 20,
    companies_cohorts_list_page: 1,
    companies_cohorts_list_loading: false,

    cohort: cohort_empty(),
    cohort_loading: false,
    cohort_saving: false,
    cohort_errors: {},
    cohort_deleting: false,
};

const actions = {
    /**
     * Загружает список когорт организации с пагинацией
     */
    [COHORTS_LIST_LOAD]({ commit, state }, { organization_id, params = {} }) {
        return api.list(
            'organization',
            `${organization_id}/cohorts`,
            params,
            state,
            commit,
            COHORTS_LIST_LOADING_CHANGE,
            COHORTS_LIST_CHANGE
        );
    },

    /**
     * Загружает список когорт организации (для выбора в форме)
     */
    [COHORTS_LIST_LOAD_SELECT]({ commit, state }, { organization_id, params = {} }) {
        return api.list(
            'organization',
            `${organization_id}/cohorts/list`,
            params,
            state,
            commit,
            COHORTS_LIST_LOADING_CHANGE_SELECT,
            COHORTS_LIST_CHANGE_SELECT
        );
    },

    /**
     * Загружает список доступных компаний(организаций) по которым есть хотя бы одна когорта
     */
    [COMPANIES_COHORTS_LIST_LOAD]({ commit, state }, { params = {} }) {
        return api.list(
            'organization.cohorts.companies',
            null,
            params,
            state,
            commit,
            COMPANIES_COHORTS_LIST_LOADING_CHANGE,
            COMPANIES_COHORTS_LIST_CHANGE
        );
    },

    /**
     * Загружает одну когорту
     */
    [COHORT_LOAD]({ commit, state }, { organization_id, cohort_id }) {
        return api.load(
            'organization',
            `${organization_id}/cohorts/${cohort_id}`,
            state,
            commit,
            COHORT_LOADING_CHANGE,
            COHORT_CHANGE,
            COHORT_ERRORS_CHANGE
        );
    },

    /**
     * Очищает текущую когорту (для формы создания)
     */
    [COHORT_SET_EMPTY]({ commit }) {
        commit(COHORT_CHANGE, null);
    },

    /**
     * Создает новую когорту
     */
    [COHORT_CREATE]({ commit, state }, { organization_id, data }) {
        return api.create(
            'organization',
            `${organization_id}/cohorts`,
            data,
            state,
            commit,
            COHORT_LOADING_CHANGE,
            COHORT_CHANGE,
            COHORT_ERRORS_CHANGE
        );
    },

    /**
     * Обновляет когорту
     */
    [COHORT_UPDATE]({ commit, state }, { organization_id, cohort_id, data }) {
        return api.update(
            'organization',
            `${organization_id}/cohorts/${cohort_id}`,
            data,
            state,
            commit,
            COHORT_SAVING_CHANGE,
            COHORT_CHANGE,
            COHORT_ERRORS_CHANGE
        );
    },

    /**
     * Удаляет когорту
     */
    [COHORT_DELETE]({ commit, state }, { organization_id, cohort_id }) {
        commit(COHORT_DELETING_CHANGE, true);
        return api.delete(
            'organization',
            `${organization_id}/cohorts/${cohort_id}`,
            state,
            commit,
            COHORT_CHANGE
        ).finally(() => {
            commit(COHORT_DELETING_CHANGE, false);
        });
    },
};

const mutations = {
    [COHORTS_LIST_LOADING_CHANGE](state, data) {
        state.cohorts_list_loading = data;
    },

    [COHORTS_LIST_CHANGE](state, data) {
        if (data?.data) {
            state.cohorts_list = data.data;
            state.cohorts_list_total = data.total;
            state.cohorts_list_per_page = data.per_page;
            state.cohorts_list_page = data.page;
        } else {
            state.cohorts_list = [];
            state.cohorts_list_total = 0;
            state.cohorts_list_per_page = 20;
            state.cohorts_list_page = 1;
        }
    },

    [COHORTS_LIST_LOADING_CHANGE_SELECT](state, data) {
        state.cohorts_list_select_loading = data;
    },

    [COHORTS_LIST_CHANGE_SELECT](state, data) {
        if (data?.data) {
            state.cohorts_list_select = data.data;
            state.cohorts_list_select_total = data.total;
            state.cohorts_list_select_per_page = data.per_page;
            state.cohorts_list_select_page = data.page;
        } else {
            state.cohorts_list_select = [];
            state.cohorts_list_select_total = 0;
            state.cohorts_list_select_per_page = 20;
            state.cohorts_list_select_page = 1;
        }
    },

    [COMPANIES_COHORTS_LIST_LOADING_CHANGE](state, data) {
        state.companies_cohorts_list_loading = data;
    },

    [COMPANIES_COHORTS_LIST_CHANGE](state, data) {
        if (data?.data) {
            state.companies_cohorts_list = data.data;
            state.companies_cohorts_list_total = data.total;
            state.companies_cohorts_list_per_page = data.per_page;
            state.companies_cohorts_list_page = data.page;
        } else {
            state.companies_cohorts_list = [];
            state.companies_cohorts_list_total = 0;
            state.companies_cohorts_list_per_page = 20;
            state.companies_cohorts_list_page = 1;
        }
    },

    [COHORT_CHANGE](state, data) {
        if (data?.data) {
            state.cohort = data.data;
        } else {
            state.cohort = cohort_empty();
        }
    },

    [COHORT_LOADING_CHANGE](state, data) {
        state.cohort_loading = data;
    },

    [COHORT_SAVING_CHANGE](state, data) {
        state.cohort_saving = data;
    },

    [COHORT_ERRORS_CHANGE](state, data) {
        state.cohort_errors = data;
    },

    [COHORT_DELETING_CHANGE](state, data) {
        state.cohort_deleting = data;
    },
    [COHORT_EMPTY](state, data) {
        state.cohort = cohort_empty();
    },
};

export default {
    state,
    actions,
    mutations,
};